module.exports = __webpack_public_path__ + "img/wechat-logo.8355598d.png";